<div class="pp-preview pp-preview--{{ provider() }}">
    <div class="pp-preview__label">
        <span>Post preview</span>
        <span class="pp-preview__hint">Approximate — updates as you type</span>
    </div>

    @switch (provider()) {

        <!-- ============================ INSTAGRAM ============================ -->
        @case ('instagram') {
            <div class="pp-card pp-card--ig">
                <div class="pp-card__head">
                    <span class="pp-avatar"></span>
                    <span class="pp-card__handle">{{ displayHandle }}</span>
                    <span class="pp-card__more" aria-hidden="true">&#8943;</span>
                </div>
                <ng-container *ngTemplateOutlet="mediaBlock; context: { shape: 'square' }" />
                <div class="pp-card__actions pp-card__actions--ig">
                    <ng-container *ngTemplateOutlet="icoHeart" />
                    <ng-container *ngTemplateOutlet="icoComment" />
                    <ng-container *ngTemplateOutlet="icoShare" />
                    <span class="pp-ico--end"><ng-container *ngTemplateOutlet="icoBookmark" /></span>
                </div>
                <div class="pp-card__body">
                    <span class="pp-card__handle pp-card__handle--inline">{{ displayHandle }}</span>
                    <ng-container *ngTemplateOutlet="captionBody" />
                </div>
            </div>
        }

        <!-- ================================ X ================================ -->
        @case ('x') {
            <div class="pp-card pp-card--x">
                <div class="pp-card__head pp-card__head--x">
                    <span class="pp-avatar"></span>
                    <div class="pp-card__namewrap">
                        <span class="pp-card__name">Your Name</span>
                        <span class="pp-card__sub">&#64;{{ displayHandle }} &middot; now</span>
                    </div>
                </div>
                <div class="pp-card__body">
                    <ng-container *ngTemplateOutlet="captionBody" />
                </div>
                <ng-container *ngTemplateOutlet="mediaBlock; context: { shape: 'wide' }" />
                <div class="pp-card__actions pp-card__actions--x">
                    <ng-container *ngTemplateOutlet="icoComment" />
                    <ng-container *ngTemplateOutlet="icoRepost" />
                    <ng-container *ngTemplateOutlet="icoHeart" />
                    <ng-container *ngTemplateOutlet="icoShare" />
                </div>
            </div>
        }

        <!-- ============================= LINKEDIN ============================ -->
        @case ('linkedin') {
            <div class="pp-card pp-card--li">
                <div class="pp-card__head">
                    <span class="pp-avatar pp-avatar--square"></span>
                    <div class="pp-card__namewrap">
                        <span class="pp-card__name">Your Name</span>
                        <span class="pp-card__sub">Your headline &middot; now</span>
                    </div>
                </div>
                <div class="pp-card__body">
                    <ng-container *ngTemplateOutlet="captionBody" />
                </div>
                <ng-container *ngTemplateOutlet="mediaBlock; context: { shape: 'wide' }" />
                <div class="pp-card__actions pp-card__actions--li">
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoThumb" />Like</span>
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoComment" />Comment</span>
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoRepost" />Repost</span>
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoShare" />Send</span>
                </div>
            </div>
        }

        <!-- ============================= FACEBOOK =========================== -->
        @case ('facebook') {
            <div class="pp-card pp-card--fb">
                <div class="pp-card__head">
                    <span class="pp-avatar"></span>
                    <div class="pp-card__namewrap">
                        <span class="pp-card__name">Your Page</span>
                        <span class="pp-card__sub">now &middot; <ng-container *ngTemplateOutlet="icoGlobe" /></span>
                    </div>
                    <span class="pp-card__more" aria-hidden="true">&#8943;</span>
                </div>
                <div class="pp-card__body">
                    <ng-container *ngTemplateOutlet="captionBody" />
                </div>
                <ng-container *ngTemplateOutlet="mediaBlock; context: { shape: 'wide' }" />
                <div class="pp-card__actions pp-card__actions--fb">
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoThumb" />Like</span>
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoComment" />Comment</span>
                    <span class="pp-act"><ng-container *ngTemplateOutlet="icoShare" />Share</span>
                </div>
            </div>
        }

        <!-- ============================= YOUTUBE ============================ -->
        @case ('youtube') {
            <div class="pp-card pp-card--yt">
                <ng-container *ngTemplateOutlet="mediaBlock; context: { shape: 'video' }" />
                <div class="pp-card__yt-title">{{ hasTitle ? titleText : 'Your video title' }}</div>
                <div class="pp-card__yt-meta">Your channel &middot; 0 views &middot; now</div>
                <div class="pp-card__yt-desc">
                    @if (hasCaption) { <div class="pp-cap__text">{{ captionText }}</div> }
                    @if (showOddrLink) {
                        <div class="pp-cap__oddr">Signed by ODDR: <span class="pp-cap__oddr-url">{{ oddrLinkDisplay }}</span></div>
                    }
                    @if (!hasCaption && !showOddrLink) {
                        <span class="pp-cap__placeholder">Your description will appear here…</span>
                    }
                </div>
            </div>
        }

        @default {
            <div class="pp-card"><div class="pp-card__body"><ng-container *ngTemplateOutlet="captionBody" /></div></div>
        }
    }
</div>

<!-- ===================== Shared: composed caption body ==================== -->
<ng-template #captionBody>
    <div class="pp-cap">
        @if (hasTitle) { <div class="pp-cap__title">{{ titleText }}</div> }
        @if (hasCaption) { <div class="pp-cap__text">{{ captionText }}</div> }
        @if (showOddrLink) {
            <div class="pp-cap__oddr">Signed by ODDR: <span class="pp-cap__oddr-url">{{ oddrLinkDisplay }}</span></div>
        }
        @if (isEmpty && !showOddrLink) {
            <span class="pp-cap__placeholder">Your caption will appear here…</span>
        }
    </div>
</ng-template>

<!-- ========================= Shared: media block ========================= -->
<ng-template #mediaBlock let-shape="shape">
    <div class="pp-media pp-media--{{ shape }}">
        @if (thumbnailUrl()) {
            <img class="pp-media__img" [src]="thumbnailUrl()" alt="Media preview" />
        } @else {
            <div class="pp-media__placeholder"><ng-container *ngTemplateOutlet="icoImage" /></div>
        }
        @if (mediaType() === 'video') {
            <div class="pp-media__play"><ng-container *ngTemplateOutlet="icoPlay" /></div>
        }
        @if (isCarousel) {
            <div class="pp-media__badge">1/{{ imageCount() }}</div>
        }
    </div>
</ng-template>

<!-- ============================== Icons (SVG) ============================= -->
<ng-template #icoHeart><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20s-7-4.35-9.5-8A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9.5 6c-2.5 3.65-9.5 8-9.5 8z" stroke-linejoin="round"/></svg></ng-template>
<ng-template #icoComment><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5z" stroke-linejoin="round"/></svg></ng-template>
<ng-template #icoShare><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 2 11 13" stroke-linecap="round"/><path d="M22 2 15 22l-4-9-9-4 20-7z" stroke-linejoin="round"/></svg></ng-template>
<ng-template #icoBookmark><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z" stroke-linejoin="round"/></svg></ng-template>
<ng-template #icoRepost><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 2l4 4-4 4" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 11V9a4 4 0 0 1 4-4h14" stroke-linecap="round"/><path d="M7 22l-4-4 4-4" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 13v2a4 4 0 0 1-4 4H3" stroke-linecap="round"/></svg></ng-template>
<ng-template #icoThumb><svg class="pp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M7 10v11H4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3z" stroke-linejoin="round"/><path d="M7 10l4-7a2.5 2.5 0 0 1 2.4 3.2L12.5 9H19a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 17.8 20H7" stroke-linejoin="round"/></svg></ng-template>
<ng-template #icoGlobe><svg class="pp-ico pp-ico--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z"/></svg></ng-template>
<ng-template #icoPlay><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></ng-template>
<ng-template #icoImage><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21" stroke-linejoin="round"/></svg></ng-template>
